/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {
    FormControl, FormHelperText, Grid, InputAdornment, InputLabel, MenuItem, Rating, TextField
} from "@mui/material";
import {AccountCircle, Brightness1} from "@mui/icons-material";
import {Controller} from "react-hook-form";
import {useEffect, useState} from "react";
import {data} from "react-router";


const IngresoRating = ({
                           props, nombre, dato, requerido = false, size = 'large', editable = true,

                       }) => {
    const {register, errors, control, setValue, watch, getValues} = props
    const [valor,setValor] = useState(2)

    const cambiar = (e) => {

        setValue(dato, e)
    }


    useEffect(() => {

        let dat = getValues(dato)
        if (dat) {
            setValor(dat)
        }else{
            setValor(2)
        }

    },[watch(dato)])
    return (
        <FormControl fullWidth>
            <InputLabel
                error={!!errors[dato]}
                shrink
                sx={{backgroundColor: '#ffffff00', px: 0, marginLeft: 0, marginTop: 0}}
                id={"labelId"}>{nombre}</InputLabel>
            <Rating
                sx={{marginTop: 1, paddingLeft: 1}}
                disabled={!editable}
                id={dato}
                size={size}
                value={valor}
                onChange={(e, value) => {
                    cambiar(value)
                }}
            >

            </Rating>
            <FormHelperText error={!!errors[dato]}>{errors[dato]?.message}</FormHelperText>
        </FormControl>
    )

}
export default IngresoRating
